import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'MovementSummary',
        isLoading: 'movementLoading',
        title: 'Movement details',
        children: [
            {
                label: 'Movement',
                fieldNames: ['Movement']
            },
            {
                label: 'Date',
                fieldNames: [
                    'MovementDate'
                ],
            },
            {
                label: 'Product',
                fieldNames: [
                    'ProductIdDisplay'
                ],
            },
            {
                label: 'Product Group',
                fieldNames: [
                    'ProductGroup'
                ],
            },
            {
                label: 'Document',
                fieldNames: [
                    'Document'
                ],
                valueRenderer: {
                    hyperLink: {
                        link: true,
                        menu: false
                    },
                },
            },
            {
                label: 'Document Reference',
                fieldNames: [
                    'DocumentReference',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: true,
                        menu: false
                    },
                },
            },
            {
                label: 'Document Account',
                fieldNames: [
                    'DocumentAccount',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: true,
                        menu: false
                    },
                },
            },

        ]
    },
    {
        objectName: 'MovementSummary',
        isLoading: 'movementLoading',
        children: [
            {
                label: 'Financial Period',
                fieldNames: [
                    'FinancialPeriod',
                ],
            },
            {
                label: 'User Id',
                fieldNames: [
                    'ResponsiblePerson',
                ],
            },
            {
                label: 'Reference',
                fieldNames: [
                    'Reference',
                ],
            },
            {
                label: 'Sales Audit',
                fieldNames: [
                    'SalesAudit',
                ],
            },
        ]
    },
    {
        objectName: 'MovementSummary',
        isLoading: 'movementLoading',
        title: 'Product Details',
        children: [
            {
                label: 'Product Type',
                fieldNames: [
                    'ProductType',
                ],
            },
            {
                label: 'Status',
                fieldNames: [
                    'ProductStatus',
                ]
            },
            {
                label: 'Pareto Class',
                fieldNames: [
                    'ParetoClass',
                ]
            },
            {
                label: 'Primary Bin',
                fieldNames: [
                    'PrimaryBin',
                ],
            },
            {
                label: 'Buying Unit',
                fieldNames: [
                    'BuyingUnit',
                ],
            },
        ]
    },
];

export default schema;
